export const CcIntroJsStyledText = (props) => {

    //props is an object like: {title: '', mainText: ''}
    let result = "<div></div>"
    if (props.title && props.title.length > 0) result += `<div class='text-xl font-semibold mb-2'>${props.title}</div>`
    if (props.mainText && props.mainText.length > 0) result += `<div class=''>${props.mainText}</div>`
    return result
}